module.exports = __webpack_public_path__ + "static/media/Step-4.68f346ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/How it works/Step-4.jpg
// module id = 300
// module chunks = 0